import { styled } from '@mui/material/styles';
import { FullHeightOnly } from '../../components/shared/Grid';

export const FullHeightOnlyCustom = styled(FullHeightOnly)(({ theme }) => ({
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: 'calc(100vh - 237px)'
  }
}));
